<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="作品用戶id" prop="byUserId" >
        <a-input v-model="form.byUserId" placeholder="请输入作品用戶id" />
      </a-form-model-item>
      <a-form-model-item label="作品類型: 1：視頻 2:赛事" prop="resourceType" >
      </a-form-model-item>
      <a-form-model-item label="资源id" prop="resourceId" >
        <a-input v-model="form.resourceId" placeholder="请输入资源id" />
      </a-form-model-item>
      <a-form-model-item label="評論id" prop="commentId" >
        <a-input v-model="form.commentId" placeholder="请输入評論id" />
      </a-form-model-item>
      <a-form-model-item label="直接上级回复ID" prop="replyId" >
        <a-input v-model="form.replyId" placeholder="请输入直接上级回复ID" />
      </a-form-model-item>
      <a-form-model-item label="評論或回复用戶id" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入評論或回复用戶id" />
      </a-form-model-item>
      <a-form-model-item label="評論或回复内容" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="被回复用戶id" prop="replyCommentUserId" >
        <a-input v-model="form.replyCommentUserId" placeholder="请输入被回复用戶id" />
      </a-form-model-item>
      <a-form-model-item label="回復數(只有評論才维护这个字段)" prop="replyNum" >
        <a-input v-model="form.replyNum" placeholder="请输入回復數(只有評論才维护这个字段)" />
      </a-form-model-item>
      <a-form-model-item label="評論回复點贊數" prop="likeNum" >
        <a-input v-model="form.likeNum" placeholder="请输入評論回复點贊數" />
      </a-form-model-item>
      <a-form-model-item label="類型  1:評論 2:回复" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="是否封禁：0-否 ，1-是" prop="isDisable" >
        <a-input v-model="form.isDisable" placeholder="请输入是否封禁：0-否 ，1-是" />
      </a-form-model-item>
      <a-form-model-item label="@用戶ids，按顺序逗号分隔" prop="atUserIds" >
        <a-input v-model="form.atUserIds" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="@用戶names，按顺序逗号分隔" prop="atUserNames" >
        <a-input v-model="form.atUserNames" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="備註" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUserComment, addUserComment, updateUserComment } from '@/api/platform/userComment'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        byUserId: null,

        resourceType: null,

        resourceId: null,

        commentId: null,

        replyId: null,

        userId: null,

        content: null,

        replyCommentUserId: null,

        replyNum: null,

        likeNum: null,

        type: null,

        isDisable: null,

        atUserIds: null,

        atUserNames: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        content: [
          { required: true, message: '評論或回复内容不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        byUserId: null,
        resourceType: null,
        resourceId: null,
        commentId: null,
        replyId: null,
        userId: null,
        content: null,
        replyCommentUserId: null,
        replyNum: null,
        likeNum: null,
        type: null,
        isDisable: null,
        atUserIds: null,
        atUserNames: null,
        createTime: null,
        remark: null,
      }
   /*   this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })*/
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUserComment({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUserComment(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUserComment(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
